import React from "react";

const GLYPHS = {
  TOP_UP: (
    <>
      <path d="M12 17V7" />
      <path d="M7.5 11.5 12 7l4.5 4.5" />
    </>
  ),
  PURCHASE: (
    <>
      <path d="M6 7h12l-1 11H7L6 7Z" />
      <path d="M9.5 7a2.5 2.5 0 0 1 5 0" />
    </>
  ),
  REFUND: (
    <>
      <path d="M12 7v10" />
      <path d="M7.5 12.5 12 17l4.5-4.5" />
    </>
  ),
  OTHER: (
    <>
      <circle cx="12" cy="12" r="5.5" />
      <path d="M12 9.5v3" />
    </>
  ),
};

const TransactionTable = ({ items, onSelect }) => (
  <div className="fin-table-wrap">
    <table className="fin-table">
      <thead>
        <tr>
          <th>Transaction</th>
          <th>Method</th>
          <th>Date</th>
          <th className="fin-table-amount-col">Amount</th>
        </tr>
      </thead>

      <tbody>
        {items.map((transaction) => {
          const credit = transaction.impact === "C";

          return (
            <tr
              key={transaction.id}
              className="fin-table-row"
              tabIndex={0}
              role="button"
              onClick={() => onSelect(transaction)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") onSelect(transaction);
              }}
            >
              <td>
                <span className="fin-table-title">
                  <span className={`fin-row-icon fin-row-icon-${credit ? "credit" : "debit"}`}>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      {GLYPHS[transaction.kind] || GLYPHS.OTHER}
                    </svg>
                  </span>

                  {transaction.title}
                </span>
              </td>

              <td className="fin-table-muted">{transaction.gatewayLabel || "—"}</td>

              <td className="fin-table-muted">
                {[transaction.dateLabel, transaction.timeLabel].filter(Boolean).join(" · ")}
              </td>

              <td
                className={`fin-table-amount-col fin-table-amount fin-table-amount-${
                  credit ? "credit" : "debit"
                }`}
              >
                {transaction.signedAmount}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default TransactionTable;
